;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  var dependencies = ['ui.router']

  angular.module('app.linkNotFound', dependencies).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.linkNotFound', {
      url: '/link-not-found?:link',
      controller: 'LinkNotFound',
      controllerAs: '$ctrl',
      hide: true,
    })
  }
})()
